import { MainLayout } from '@/shared/ui/Layout/MainLayout/MainLayout'

export const layoutWithSidebar = <MainLayout />
